import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useUpdateCheck } from './useUpdateCheck';

/**
 * "A new version is available", as a small card in the bottom-right corner,
 * once a deploy has happened under an open tab. Same pattern as the Grasp
 * app (ClickUp, Linear and Notion do it this way): present, out of the way of
 * the conversation, one action.
 *
 * TWO WAYS OUT, BOTH A FULL RELOAD. The button reloads now; failing that, the
 * app reloads itself at the next route change, where nothing in progress can
 * be lost — which is why it does NOT reload the instant the check comes back:
 * a message half-typed into the chat is the learner's until they leave it.
 *
 * NOT DISMISSABLE: that would promise to keep running a bundle whose chunks
 * are already being deleted from the server.
 */
function UpdateToast() {
  const { available, served } = useUpdateCheck();
  const location = useLocation();
  const pathAtDiscovery = useRef(null);

  useEffect(() => {
    if (!available) {
      pathAtDiscovery.current = null;
      return;
    }
    if (pathAtDiscovery.current === null) {
      pathAtDiscovery.current = location.pathname;
      return;
    }
    if (location.pathname !== pathAtDiscovery.current) {
      window.location.reload();
    }
  }, [available, location.pathname]);

  if (!available) return null;

  return (
    <div className="update-toast" role="status" aria-live="polite">
      <span className="update-toast-icon" aria-hidden="true">
        ↻
      </span>
      <div className="update-toast-body">
        <p className="update-toast-title">A new version of Grasp is available</p>
        <p className="update-toast-text">
          {served && served.version ? `Version ${served.version} is ready. ` : ''}
          Refresh to get it; the app also refreshes when you move to another page.
        </p>
        <button type="button" className="update-toast-button" onClick={() => window.location.reload()}>
          Refresh
        </button>
      </div>
    </div>
  );
}

export default UpdateToast;
